import { anonymizeUserData } from '@masterplandev/utils'

export const stateSanitizer = anonymizeUserData

export default stateSanitizer
